import { render } from "./ActivityView.vue?vue&type=template&id=a2dd48c4&scoped=true"
import script from "./ActivityView.vue?vue&type=script&lang=js"
export * from "./ActivityView.vue?vue&type=script&lang=js"

import "./ActivityView.vue?vue&type=style&index=0&id=a2dd48c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2dd48c4"]])

export default __exports__